import { Button } from "@design-system/Button/Button";
import { WithHotkey } from "@design-system/Button/WithHotkey";
import { CommandIsland } from "@design-system/CommandIsland/CommandIsland";
import commandIslandStyles from "@design-system/CommandIsland/CommandIslandVariants.module.scss";
import { Switch } from "@design-system/Switch/Switch";

interface TaskCreationFormFooterProps {
    isCreateMore: boolean;
    onCreateMoreChange: (isCreateMore: boolean) => void;
    isSubmitting: boolean;
    submitLabel: string;
}

export const TaskCreationFormFooter = ({
    isCreateMore,
    onCreateMoreChange,
    isSubmitting,
    submitLabel,
}: TaskCreationFormFooterProps) => (
    <CommandIsland
        sticky
        className={commandIslandStyles.bulkActionsStickyFooter}
    >
        <Switch
            checked={isCreateMore}
            onCheckedChange={onCreateMoreChange}
            label="Create more"
        />
        <WithHotkey
            hotKey="mod+enter"
            hotKeyDisplayPosition="inline"
            hotKeyOptions={{
                enableOnFormTags: true,
                description: "Create task submit",
            }}
        >
            {(hotkeyHint) => (
                <Button
                    type="submit"
                    variant="primary"
                    size="md"
                    disabled={isSubmitting}
                    className="ml-auto"
                    rightIcon={hotkeyHint}
                >
                    {isSubmitting ? "Creating…" : submitLabel}
                </Button>
            )}
        </WithHotkey>
    </CommandIsland>
);
